import React, { useEffect, useRef, useState } from 'react';
import '../../../KodanshaWheel/KodanshaWheel.scss';
import './VolumesWheel.scss';
import SliderArrow from '../../../Assets/icons/SliderArrow';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper';
import { FreeModeOptions } from 'swiper/types/modules/free-mode';
import { Link } from '../../../../Devon/Components/InkyLink';
import { clearBrowseData } from '../../../../utils/utils';
import KodanshaArrow from '../../../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import { useWindowSize } from '../../../Hooks/useWindowSize';
import { useAtom } from 'jotai';
import { FetchWheelAtom } from '../../../../store/DiscoverStore';
import { Swiper as T } from 'swiper/types';
import VolumeWheelItem from './VolumeWheelItem';
import 'swiper/css';
import 'swiper/css/virtual';
import { Product } from '../../../../Models/Product';
import Log from '../../../Services/Logger';

const copyArray = (arr, times) => {
    if (times <= 0) {
        return [];
    }
    return arr.concat(copyArray(arr, times - 1));
};

const VolumesWheel = (props) => {
    const { width } = useWindowSize();

    const [shadowSize, setShadowSize] = useState<{ width: number; height: number; top: number }>({
        width: 0,
        height: 0,
        top: 0,
    });

    const slidesPerView = useRef(10);

    const [wheelContainerSize, setWheelContainerSize] = useState<number>(0);

    const [hover, setHover] = useState(false);
    // const [test, setTest] = useState(false);

    const [mainTitle, setMainTitle] = useState('');
    const [page, setPage] = useState(0);
    const ref = useRef<any>();
    const SwiperRef = useRef<T>();

    const calculateWheelItemSize = (): { width: number; height: number; top: number } => {
        // If we don't have any items in the wheel, we don't need to run this function
        // To make a copy of series height from the shadow for the shadow
        const children = ref.current?.children;
        try {
            if (children && children.length > 0 && children[0].children[0]) {

                const exactChild = children[0].children[0].children[0].children[0].children[0];

                setShadowSize({
                    width: exactChild.getBoundingClientRect().width,
                    height: exactChild.getBoundingClientRect().height,
                    top: exactChild.getBoundingClientRect().top,
                });
                return {
                    width: exactChild.getBoundingClientRect().width,
                    height: exactChild.getBoundingClientRect().height,
                    top: exactChild.getBoundingClientRect().top,
                };
            }
        } catch (error) {
            console.log('error', error);
        }


        return { width: 0, height: 0, top: 0 };
    };

    const onNextClicked = () => {
        SwiperRef.current.slideNext();
    };

    const onPrevClicked = () => {
        SwiperRef.current.slidePrev();
    };


    useEffect(() => {
        props.currentIndex && SwiperRef.current.slideTo(props.currentIndex);
    }, [props.currentIndex]);

    useEffect(() => {
        setWheelContainerSize(ref.current.getBoundingClientRect().height);

        //This is temp until we add this to the endpoint.
        setMainTitle(props.title);
        const splitTitle = props.title?.split('#');
        if (splitTitle?.length > 1) {
            setMainTitle(splitTitle[1].toString());
        }
        //End Temp

        const onArrow = (event) => {
            if (event.code === 'ArrowRight') {
                onNextClicked();
            }

            if (event.code === 'ArrowLeft') {
                onPrevClicked();
            }
        };

        document.addEventListener('keydown', onArrow);

        return () => {
            document.removeEventListener('keydown', onArrow);
        };

    }, []);


    return (
        <section onMouseOver={(): void => {
            wheelContainerSize !== 0 && calculateWheelItemSize() && setHover(true);
        }} onMouseLeave={(): void => setHover(false)} className='volume-wheel-container kodansha-wheel-container'>

            <div className='max-kodansha-wheel-container'>
                {width > 1278 && hover && wheelContainerSize !== 0 &&
                    // {test &&
                    <>

                        <div onClick={onPrevClicked} className='wheel-shadow-container'
                             aria-label={'go to previous slide'}
                             style={{
                                 width: shadowSize.width * 4,
                                 height: shadowSize.height,
                                 left: -4 * shadowSize.width,
                             }}>


                            {page !== 0 &&
                                <div className='prev navigation-icons'
                                     onClick={(e) => {
                                         e.stopPropagation();
                                         onPrevClicked();
                                     }}
                                     style={{
                                         right: 15,
                                         top: shadowSize.height / 2 - 17.5, // 17.5 half of the arrow size
                                     }}>
                                    <SliderArrow />
                                </div>}

                            <div className='wheel-shadow-inner-wrapper'>
                                <div className='inner-relative wheel-shadow-container-left'>
                                    {Array.from(Array(Math.min(SwiperRef.current.realIndex,
                                        slidesPerView.current)).keys()).map((data => {
                                        return <div style={{ minWidth: shadowSize.width }} key={data}
                                                    className='shadow-item' />;
                                    }))}
                                </div>
                            </div>
                        </div>


                        <div onClick={onNextClicked}
                             aria-label={'go to next slide'}
                             className='wheel-shadow-container'
                             style={{
                                 width: shadowSize.width * 4,
                                 height: shadowSize.height,
                                 right: -4 * shadowSize.width,
                             }}>

                            {SwiperRef.current.slides.length - SwiperRef.current.realIndex > slidesPerView.current &&
                                <div className='next navigation-icons'
                                     onClick={(e) => {
                                         e.stopPropagation();
                                         onNextClicked();
                                     }}
                                     style={{
                                         left: 15,
                                         top: shadowSize.height / 2 - 17.5, // 17.5 half of the arrow size
                                     }}>
                                    <SliderArrow />

                                </div>}

                            <div className='wheel-shadow-inner-wrapper'>
                                <div className='inner-relative wheel-shadow-container-right'>
                                    {SwiperRef.current.slides.length - SwiperRef.current.realIndex > slidesPerView.current && Array.from(Array(Math.min(SwiperRef.current.slides.length - SwiperRef.current.realIndex - slidesPerView.current,
                                        slidesPerView.current)).keys()).map((data => {
                                        return <div style={{ minWidth: shadowSize.width }} key={data}
                                                    className='shadow-item' />;
                                    }))}
                                </div>
                            </div>
                        </div>

                    </>}

                <div className={'KodanshaWheel'}>

                    <div className='wheel-header'>
                        <div className='wheels-titles-wrapper'>
                            {/*<h3 aria-label={'second title for wheels' + props.secondTitle}*/}
                            {/*    className={'wheel-second-title'}>{props.secondTitle ?? secondTitle}</h3>*/}
                            <h2 aria-label={'main title for wheels' + mainTitle}
                                className={'wheel-title'}>{mainTitle}</h2>
                        </div>
                    </div>

                    {<Swiper
                        ref={ref}
                        spaceBetween={15}
                        slidesPerView={2}
                        slidesPerGroup={2}
                        touchEventsTarget={'container'}
                        freeMode={width < 1278}
                        modules={[FreeMode]}
                        longSwipesRatio={0.01}
                        onSwiper={(swiper) => {
                            SwiperRef.current = swiper;
                        }}
                        navigation={{
                            prevEl: '.prev',
                            nextEl: '.next',
                        }}
                        onResize={(swiper) => {
                            swiper.params.freeMode = {
                                ...swiper.params.freeMode as FreeModeOptions,
                                enabled: width < 1278,
                            };
                            // (swiper.params.freeMode as FreeModeOptions).enabled = width < 768;
                            ref.current && setWheelContainerSize(ref.current.getBoundingClientRect().height);
                            calculateWheelItemSize();
                            swiper.update();
                        }}
                        onEnded={() => {
                            setPage(999);
                        }}
                        onSlideChange={() => {
                            setPage(SwiperRef.current.realIndex);
                        }}
                        breakpoints={{
                            320: {
                                slidesPerView: 4.2,
                                slidesPerGroup: 4,
                            },
                            576: {
                                slidesPerView: 4.2,
                                slidesPerGroup: 4,
                            },
                            1278: {
                                slidesPerView: 10,
                                slidesPerGroup: 10,
                            },
                        }}
                    >
                        {(props.volumes as Product[]).map((volume, index) => {
                            Log.debug('volume.volumeNumber', volume.volumeNumber);
                            return <SwiperSlide key={index}>
                                <div aria-label={'main wheel'} className='ItemContainer'>
                                    <VolumeWheelItem volume={volume}
                                                     number={index + 1}
                                                     currentVolume={props.currentVolume === volume.id} />
                                </div>
                            </SwiperSlide>;
                        })}
                    </Swiper>}
                </div>


                {props.useCTA === true && <div className={'cta'}>
                    <Link to={'/series/' + props.series?.readableUrl}>
                        <KodanshaArrow text={props?.ctaText ? props.ctaText : 'Go To Series'} withArrow={true} />
                    </Link>
                </div>}

            </div>

        </section>
    );
};

export default VolumesWheel;